//Styles
import { Wrapper, Image } from "./Actor.styled";

const Actor = ({ name, character, imageUrl }) => (
    <Wrapper>
        <Image src={imageUrl} alt="actor-thumb" />
        <div className="bottom">
            <h3>{name}</h3>
            <p>{character}</p>
        </div>
    </Wrapper>
);

export default Actor;
